import React from "react";
import { Table, Button } from "reactstrap";
import {
  MINIJUEGOS,
  HISTORIAS,
  PLANETAS,
  NIVELES,
  CINTURONES,
} from "./consts_act";
import {
  displayTimeDiff,
  parseDate, renderActivityListCordonesAsteroides,
  renderActivityListHistoriasLeidas,
  renderActivityListMiniJuegos, renderActivityListNiveles, renderActivityListPlanetas
} from "../../../../utils/helperMethods";

export default class TablaActivity extends React.Component {
  render() {
    if (!this.props.activity) return null;

    switch (this.props.activity) {
      case MINIJUEGOS:
        return <div>{renderActivityListMiniJuegos(
            this.props.data,
            () => this.props.paginate(0),
            () => this.props.paginate(1),
            this.props.page
        )}</div>;
      case HISTORIAS:
        return <div>{renderActivityListHistoriasLeidas(
            this.props.data,
            () => this.props.paginate(0),
            () => this.props.paginate(1),
            this.props.page
        )}</div>;
      case PLANETAS:
        return <div>{renderActivityListPlanetas(
            this.props.data,
            () => this.props.paginate(0),
            () => this.props.paginate(1),
            this.props.page
        )}</div>;
      case NIVELES:
        return <div>{renderActivityListNiveles(
            this.props.data,
            () => this.props.paginate(0),
            () => this.props.paginate(1),
            this.props.page
        )}</div>;
      case CINTURONES:
        return <div>{renderActivityListCordonesAsteroides(
            this.props.data,
            () => this.props.paginate(0),
            () => this.props.paginate(1),
            this.props.page
        )}</div>;
      default:
        return null;
    }
  }
}



// WEBPACK FOOTER //
// src/Pages/Demografico/Familia/component/ActivityList.js